import { createSlice, PayloadAction } from "@reduxjs/toolkit";


interface InitialState {
    data: boolean,
    error: string,
    loading: boolean
}
const initialState: InitialState =
{
    data: false,
    error: '',
    loading: false
}

const displayAppraisalControlsSlice = createSlice({
    name: "displayAppraisalControls",
    initialState,
    reducers: {
        updateFlagToDisableControlesForAppraisal(state, action: PayloadAction<boolean>) {
            state.data = action.payload;
        },
    },
});

export const { updateFlagToDisableControlesForAppraisal } = displayAppraisalControlsSlice.actions;

export default displayAppraisalControlsSlice.reducer;